export default __webpack_public_path__ + "static/media/user-accout.03951521.svg";